import {hostedCheckoutSvg as Icon__small__hostedCheckoutSvg} from '../Icon__small/Icon__small--hostedCheckout.js';
import {hostedCheckoutSvg as Icon__xsmall__hostedCheckoutSvg} from '../Icon__xsmall/Icon__xsmall--hostedCheckout.js';

export var hostedCheckout = {
  name: 'hostedCheckout',
  category: 'icon',
  colorable: true,
  svg: Icon__small__hostedCheckoutSvg,
  alt: {
    Icon__small: Icon__small__hostedCheckoutSvg,
    Icon__xsmall: Icon__xsmall__hostedCheckoutSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
